var _style, _path, _path2, _path3, _path4, _path5, _path6, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 56 56",
    style: {
      enableBackground: "new 0 0 56 56"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#5B5B5B;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "options") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28,0C12.5,0,0,12.5,0,28s12.5,28,28,28s28-12.5,28-28S43.5,0,28,0z M28,54C13.6,54,2,42.4,2,28S13.6,2,28,2 s26,11.6,26,26S42.4,54,28,54z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.6,38h-7.5c-0.3,0-0.6,0.3-0.6,0.6s0.3,0.6,0.6,0.6h7.5c0.3,0,0.6-0.3,0.6-0.6S29,38,28.6,38z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39.9,18.8l-6.6-6.6C33.2,12.1,33,12,32.9,12H18.7c-1.5,0-2.7,1.2-2.7,2.7v26.7c0,1.5,1.2,2.7,2.7,2.7h18.7 c1.5,0,2.7-1.2,2.7-2.7v-22C40,19.1,40,19,39.9,18.8z M33.4,14.2l4.4,4.4h-3.1c-0.7,0-1.3-0.6-1.3-1.3 C33.4,17.3,33.4,14.2,33.4,14.2z M37.4,42.7H18.7c-0.7,0-1.3-0.6-1.3-1.3V14.8c0-0.7,0.6-1.3,1.3-1.3H32v3.8c0,1.5,1.2,2.7,2.7,2.7 h4.1v21.3C38.7,42.1,38.1,42.7,37.4,42.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35.4,30.7H20.7c-0.3,0-0.6,0.3-0.6,0.6s0.3,0.6,0.6,0.6h14.7c0.3,0,0.6-0.3,0.6-0.6S35.7,30.7,35.4,30.7z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35.4,26.7H20.7c-0.3,0-0.6,0.3-0.6,0.6c0,0.3,0.3,0.6,0.6,0.6h14.7c0.3,0,0.6-0.3,0.6-0.6 C36.1,27,35.7,26.7,35.4,26.7z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35.4,34.6H20.7c-0.3,0-0.6,0.3-0.6,0.6s0.3,0.6,0.6,0.6h14.7c0.3,0,0.6-0.3,0.6-0.6 C36.1,34.9,35.7,34.6,35.4,34.6z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.2,22.1c-0.1,0.1-0.3,0.1-0.5,0.2c0.2,0,0.3,0.1,0.5,0.2l1.6,0.8c0.1,0,0.1,0.1,0.1,0.1c0,0.1,0,0.1,0,0.2 v0.8l-3.6-1.9V22l3.6-1.9V21c0,0.1,0,0.1,0,0.2c0,0-0.1,0.1-0.1,0.1L22.2,22.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.4,25.3c-0.1,0.1-0.1,0.2-0.2,0.3s-0.2,0.1-0.3,0.1h-0.5L28,19c0-0.1,0.1-0.2,0.2-0.3 c0.1-0.1,0.2-0.1,0.3-0.1H29L26.4,25.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.8,22v0.5l-3.6,1.9v-0.8c0-0.1,0-0.1,0-0.2c0-0.1,0.1-0.1,0.1-0.1l1.6-0.8c0.1-0.1,0.3-0.1,0.5-0.2 c-0.2,0-0.3-0.1-0.5-0.2l-1.6-0.8c-0.1,0-0.1-0.1-0.1-0.1c0,0,0-0.1,0-0.2v-0.8L33.8,22z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPages);
export default __webpack_public_path__ + "static/media/pages.097c0fba5a67ed87db71ba6a8db2b151.svg";
export { ForwardRef as ReactComponent };